"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serializeObject = serializeObject;
function serializeObject(obj) {
  return Object.keys(obj).map(function (key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  }).join('&');
}